import { render, staticRenderFns } from "./HeaderTransactions.vue?vue&type=template&id=834779de&scoped=true&"
import script from "./HeaderTransactions.vue?vue&type=script&lang=js&"
export * from "./HeaderTransactions.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTransactions.vue?vue&type=style&index=0&id=834779de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834779de",
  null
  
)

export default component.exports